export default __webpack_public_path__ + "static/media/Walking_Along.9be59f00.mp3";